// @ts-nocheck
import {
  FormulaHelpers,
  WildCard,
  Types,
  FormulaError,
} from 'fast-formula-parser';

const H = FormulaHelpers;

export const Match = (lookupValue, tableArray, rangeLookup) => {
  lookupValue = H.accept(lookupValue);
  rangeLookup = H.accept(rangeLookup, Types.BOOLEAN, true);

  if (tableArray?.isRangeRef) {
    // Only Single Row | Col reference is accepted
    if (
      tableArray.value &&
      tableArray.value.length > 1 &&
      tableArray.value[0] &&
      tableArray.value[0].constructor === Array &&
      tableArray.value[0].length > 1
    ) {
      throw FormulaError.REF;
    }

    try {
      tableArray = H.accept(tableArray, Types.ARRAY, undefined, true);
    } catch (e) {
      // catch #VALUE! and throw #N/A
      if (e instanceof FormulaError) throw FormulaError.NA;
      throw e;
    }
  } else if (tableArray?.isCellRef || tableArray?.value) {
    tableArray = [H.accept(tableArray)];
  } else {
    throw FormulaError.REF;
  }

  const lookupType = typeof lookupValue;
  if (rangeLookup) {
    let prevValue = lookupType === typeof tableArray[0] ? tableArray[0] : null;
    let prevValueIndex = lookupType === typeof tableArray[0] ? 0 : -1;
    for (let i = 1; i < tableArray.length; i++) {
      // const currRow = tableArray[i];
      const currValue = tableArray[i];
      // console.log('i', i, currValue, prevValue)
      const type = typeof currValue;
      // skip the value if type does not match
      if (type !== lookupType) continue;

      // if the previous two values are greater than lookup value, throw #N/A
      if (prevValue > lookupValue && currValue > lookupValue) {
        throw FormulaError.NA;
      }

      if (currValue === lookupValue) return i + 1;
      // if previous value <= lookup value and current value > lookup value
      if (
        prevValue != null &&
        currValue > lookupValue &&
        prevValue <= lookupValue
      ) {
        // return i;
        return prevValueIndex + 1;
      }
      prevValue = currValue;
      prevValueIndex = i;
    }

    if (prevValueIndex == -1) throw FormulaError.NA;
    return prevValueIndex + 1;
  }
  // exact lookup with wildcard support
  else {
    let index = -1;
    if (WildCard.isWildCard(lookupValue)) {
      index = tableArray.findIndex((currRow) => {
        return WildCard.toRegex(lookupValue, 'i').test(currRow);
      });
    } else {
      index = tableArray.findIndex((currRow) => {
        return currRow === lookupValue;
      });
    }
    // the exact match is not found
    if (index === -1) throw FormulaError.NA;
    // return tableArray[index][colIndexNum - 1];
    return index + 1;
  }
};
